// assets
import { ImportOutlined, FileTextOutlined } from '@ant-design/icons';

// icons
const icons = {
    ImportOutlined,
    FileTextOutlined
  };

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const nhapxuat = {
  id: 'nhapxuat',
  title: 'Nhập / Xuất Dữ Liệu',
  type: 'group',
  children: [
    {
      id: 'nhap-du-lieu-can',
      title: 'Nhập Dữ Liệu Cân',
      type: 'item',
      url: '/nhapdulieucan',
      icon: icons.ImportOutlined,
      breadcrumbs: false
    },
    {
      id: 'quan-ly-in-phieu',
      title: 'Quản Lý In Phiếu',
      type: 'item',
      url: '/quanlyinphieu',
      icon: icons.FileTextOutlined,
      breadcrumbs: false
    }
  ]
};

export default nhapxuat;
